import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ControlIconButton from './ControlIconButton';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import RenameFileDialogue from './RenameFileDialogue';
import DeleteFileDialogue from './DeleteFileDialogue';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  list: {
    padding: 0,
    listStyleType: 'none',
    paddingInlineStart: 0,
  },
  listIconButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  listIcon: {
    color: theme.palette.primary.main,
    marginRight: '6px',
    fontSize: '1rem',
  },
}));

const DocumentItemActions = ({data, downloadFile, renameFile, deleteFile}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [renameDialogueOpen, setRenameDialogueOpen] = useState(false);
  const [deleteDialogueOpen, setDeletDialogueOpen] = useState(false);

  const openMoreMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMoreMenu = () => {
    setAnchorEl(null);
  };

  const openRename = () => {
    closeMoreMenu();
    setRenameDialogueOpen(true);
  };

  const openDelete = () => {
    closeMoreMenu();
    setDeletDialogueOpen(true);
  };

  return (
    <div className={classes.root}>
      <ControlIconButton
        label="Download file"
        icon="download"
        onClick={()=>downloadFile(data.uuid)}
      />
      <ControlIconButton
        label="More options"
        icon="more"
        onClick={openMoreMenu}
      />
      <Popover
        id="more-actions"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closeMoreMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List className={classes.list}>
          <ListItem button>
            <IconButton
              className={classes.listIconButton}
              onClick={openRename}
            >
              <EditIcon className={classes.listIcon} />
              <Typography variant="body2" color="primary">Rename</Typography>
            </IconButton>
          </ListItem>
          <ListItem button>
            <IconButton
              className={classes.listIconButton}
              onClick={openDelete}
            >
              <DeleteIcon className={classes.listIcon} />
              <Typography variant="body2" color="primary">Delete</Typography>
            </IconButton>
          </ListItem>
        </List>
      </Popover>
      <RenameFileDialogue
        open={renameDialogueOpen}
        onClose={()=>setRenameDialogueOpen(false)}
        data={data}
        renameFile={renameFile}
      />
      <DeleteFileDialogue
        open={deleteDialogueOpen}
        onClose={()=>setDeletDialogueOpen(false)}
        data={data}
        deleteFile={deleteFile}
      />
    </div>
  );
};

DocumentItemActions.propTypes = {
  data: PropTypes.object.isRequired,
  downloadFile: PropTypes.func.isRequired,
  renameFile: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
};

export default DocumentItemActions;
